var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, makeAutoObservable, makeObservable } from 'mobx';
import _ from 'lodash';
import { insurancesService } from 'ziphy-web-shared/basic/api';
import { getUuid } from 'ziphy-web-shared/basic/helpers';
import { $loader, globalLoaderHandlers } from 'ziphy-web-shared/basic/utils';
import { ContextController, GlobalStorage, IdsController } from '../storageManager';
/*
 * GlobalStorage
 */
class InsurancesGlobalStorage extends GlobalStorage {
    constructor() {
        super({ idKey: 'id', updateCondition: (x) => (x === null || x === void 0 ? void 0 : x.Type) === 'insurance' });
        makeObservable(this, {
            list: action,
        });
    }
    list(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield insurancesService.list(params, options);
        });
    }
}
export const $insurancesGlobalStorage = new InsurancesGlobalStorage();
/*
 * Templates
 */
class InsurancesStore {
    constructor(key = getUuid(), storage = $insurancesGlobalStorage) {
        this.contextKey = key;
        this.storage = storage;
        this.itemsIds = new IdsController();
        makeAutoObservable(this);
    }
    // Items
    get items() {
        return this.itemsIds.list.map((id) => this.getById(id)).filter((x) => x);
    }
    get sortedItems() {
        return _.orderBy(this.items, ['isPrimary', (x) => (x.createdTime ? x.createdTime : '')], ['desc', 'desc']);
    }
    getById(id) {
        return this.storage.asObject[id];
    }
    // Actions
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield insurancesService.create(this.withContext(params), options);
            if (!response.error) {
                if (params.isPrimary) {
                    yield this.list();
                }
                else {
                    this.itemsIds.add(response.preparedValue.id);
                }
            }
            return response;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield insurancesService.read(this.withContext(params), options);
        });
    }
    delete(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield insurancesService.delete(this.withContext(params), options);
            if (!response.error)
                this.itemsIds.delete(params.id);
            return response;
        });
    }
    list(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield insurancesService.list(this.withContext(params), options);
            if (!response.error)
                this.itemsIds.set(response.preparedValue.map((x) => x.id));
            return response;
        });
    }
    setPrimary(params, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield insurancesService.setPrimary(this.withContext(params), options);
            if (!response.error)
                yield this.list();
            return response;
        });
    }
    //////
    withContext(params) {
        return Object.assign(Object.assign({}, params), { patientId: this.contextKey });
    }
}
export const $insurancesContexts = new ContextController((key) => new InsurancesStore(key));
/*
 * Other
 */
$loader.subscribe(globalLoaderHandlers.LOGOUT, () => {
    $insurancesGlobalStorage.clear();
    $insurancesContexts.clear();
});
